import React from "react";
import { useTranslation } from "react-i18next";

export interface IHookFormSubmitButtonProps {
  className?: string;
  label?: string;
  disabled?: boolean;
}

export const HookFormSubmitButton = ({
  className,
  label,
  disabled,
}: IHookFormSubmitButtonProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`hookForm.submitButton.${key}`);

  return (
    <button
      className={`btn ${disabled ? "btn-border" : "btn-blue"} ${className}`}
      type="submit"
      disabled={disabled}
    >
      {label || t("submit")}
    </button>
  );
};
